var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.chartData.datasets.length > 0)?_c('line-chart',{staticClass:"chart-panel",attrs:{"data":_vm.chartData,"height":250,"options":_vm.chartOptions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }